module.exports = __webpack_public_path__ + "img/btn_preview.d96fe51a.svg";